<template>
  <div class="dt-copyright" :style="{ background: bg }">
    <div class="dt-copyrightWrap" :style="{ color: color, width: width }">
      <div class="line">
        <p>
          <span style="margin-right: 50px"
            >用户权限：<i
              class="link"
              @click="
                $sa('welfareStaffIndexElementClick', {
                  $element_name: '用户权限',
                });
                handlePDF('user');
              "
              >查看权限</i
            ></span
          >
          隐私权限：<i
            class="link"
            @click="
              $sa('welfareStaffIndexElementClick', {
                $element_name: '隐私权限',
              });
              handlePDF('privacy');
            "
            >查看权限</i
          >
        </p>
        <p>
          联系邮箱：<a
            class="link"
            @click="
              $sa('welfareStaffIndexElementClick', {
                $element_name: '联系邮箱',
              })
            "
            href="mailto:DTBROKER@dtinsure.com"
            >DTBROKER@dtinsure.com</a
          >
        </p>
        <p>联系邮箱：<a class="link" @click="$sa('welfareStaffIndexElementClick')" href="mailto:DTBROKER@dtinsure.com">DTBROKER@dtinsure.com</a></p>
      </div>
      <div style="border-top: 1px solid #dcdce1; margin: 15px 0" />
      <div>ICP备案信息：<a class="link" href="https://beian.miit.gov.cn/" target="_blank">{{ tenantId == "T0002" ? "琼ICP备2023009638号" : "京ICP备12000891号" }}</a></div>
      <div>保险销售许可：{{tenantId == "T0002" ?"大童保险经纪有限公司 (保险中介许可证：260959000000800)":"大童保险销售服务有限公司（保险中介许可证：204016000000800）"}}</div>
      <div>
        中国银保监会网销许可 Copyright©<a class="link" v-if="tenantId=='T0002'" href="https://www.91datong.com/" target="_blank"
          >大童保险经纪有限公司</a>
          <a class="link" v-if="tenantId=='T0001'" href="https://www.dtinsure.com/dtsite/pc/" target="_blank"
          >大童保险销售服务有限公司</a>
        All Rights Reserved
      </div>
    </div>
  </div>
</template>

<script>
import {getTenantId} from '@/utils/utils'
export default {
  props: {
    bg: {
      type: String,
      default: '#f5f5f5',
    },
    color: {
      type: String,
      default: '#aaa',
    },
    width: {
      type: String,
      default: '1200px',
    },
  },
  data() {
    return {};
  },
  computed: {
    tenantId() {
      return getTenantId()
    }
  },
  methods: {
    handlePDF(type) {
      this.$sa('welfareStaffIndexElementClick');
      let t = this.tenantId == "T0002"?"":"销售"

      let baseUrl = getTenantId()=="T0001"?"/dtqk/pc/":"/bbc/pc/"

      type == 'user'
        ? window.open(`${baseUrl}用户注册协议${t}.pdf`)
        : window.open(`${baseUrl}个人信息保护政策${t}.pdf`);
      
    },
  },
};
</script>

<style lang="less" scoped>
.dt-copyright {
  padding: 40px 0;
  background-color: #f5f5f5;
  .dt-copyrightWrap {
    width: @contentWidth;
    margin: 0 auto;
    color: #aaa;
    font-size: 16px;
    line-height: 2;
  }
  .line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .link {
      text-decoration: underline;
    }
  }
  .link {
    .dt-hover;
  }
}
</style>
